import Layout from "../../../../components/layout/Layout";
import { useFrontofficeContext } from "../../../../context/FrontofficeContext";
import { useLanguageContext } from "../../../../context/LanguageContext";
import { StyledAltButton } from "../../../../styles/ButtonStyles";
import { StyledFlexColumn } from "../../../../styles/LayoutStyles";
import { StyledStatusDescription, StyledStatusText } from "./MessagePageStyles";

function MessagePageView() {
  const { terminal, pageParams, updatePage } = useFrontofficeContext();
  const { translate } = useLanguageContext();

  return (
    <Layout
      layoutData={terminal?.layout}
      content={
        <StyledFlexColumn>
          <StyledStatusDescription>{pageParams?.title}</StyledStatusDescription>
          <StyledStatusText>{pageParams?.message}</StyledStatusText>
          <StyledAltButton onClick={() => updatePage("start")}>
            {translate("eva.frontoffice.general.back")}
          </StyledAltButton>
        </StyledFlexColumn>
      }
    />
  );
}

export default MessagePageView;
